/* FizzyIQ — Mission Highlight Text
   Swaps [img1]/[img2]/[img3]/[pill] placeholders in the statement text with
   the inline media stashed in the section <template>, then zoom-reveals the
   inline images as they scroll into view. */
(function () {
  if (window.customElements && customElements.get('fizzy-highlight-text')) return;

  class FizzyHighlightText extends HTMLElement {
    connectedCallback() {
      if (this._done) return;
      this._done = true;
      this.replacePlaceholders();
      this.observeReveal();
    }

    replacePlaceholders() {
      const section = this.closest('[id^="fmht-"]') || this.closest('.fizzy-mission-highlight-text-section');
      const tpl = section && section.querySelector('template');
      if (!tpl) return;

      const media = {};
      tpl.content.querySelectorAll('[data-id]').forEach((node) => {
        media[node.getAttribute('data-id')] = node.outerHTML;
      });

      // Replace [img1], [img2], [img3], [pill] tokens with their media markup.
      this.innerHTML = this.innerHTML.replace(/\[(img\d+|pill)\]/g, (match, key) => {
        return media[key] !== undefined ? media[key] : '';
      });
    }

    observeReveal() {
      const imgs = this.querySelectorAll('.fmht__inline-img');
      if (!imgs.length) return;

      const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || !('IntersectionObserver' in window)) {
        imgs.forEach((el) => el.classList.add('is-revealed'));
        return;
      }

      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.2 });

      imgs.forEach((el) => io.observe(el));
    }
  }

  customElements.define('fizzy-highlight-text', FizzyHighlightText);
})();
